var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadIconSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19176_76190)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0432 6.1426C11.3002 5.91014 11.7167 5.91014 11.9736 6.1426C12.2306 6.37505 12.2306 6.75194 11.9736 6.98439L8.46488 10.159C8.20795 10.3915 7.7914 10.3915 7.53447 10.159L4.0257 6.98439C3.76878 6.75194 3.76878 6.37505 4.0257 6.1426C4.28262 5.91014 4.69918 5.91014 4.9561 6.1426L7.34176 8.30105V2.35714C7.34176 2.1599 7.63631 2 7.99966 2C8.363 2 8.65755 2.1599 8.65755 2.35714V8.30108L11.0432 6.1426ZM2.16634 12.8333H13.833C14.2932 12.8333 14.6663 13.165 14.6663 13.5741C14.6663 13.9832 14.2932 14.3148 13.833 14.3148H2.16634C1.7061 14.3148 1.33301 13.9832 1.33301 13.5741C1.33301 13.165 1.7061 12.8333 2.16634 12.8333Z",
    fill: "#A614B9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19176_76190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIconSmall);
export default __webpack_public_path__ + "static/media/download-icon-small.afbd8329631abf572d781a8063850b72.svg";
export { ForwardRef as ReactComponent };